module.exports = __webpack_public_path__ + "static/886f28f4b4e686d2465f781304bcf0e0c191d645c060fbbc3054cfc73b71488c-b5059742f479035227d12b367a7f6936.png";